module.exports = "/images/img--avatar-logo@2x.svg?b2bed96abb914d46ebd8a26b7802142d";